import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_GLOBALS_DATATABLE: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/project-global-template/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBAL: ({ commit, dispatch }, globalId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/project-global-template/${globalId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBAL_TEMPLATE: ({ commit, dispatch }, globalTemplateId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/global-template/${globalTemplateId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBALS_TEMPLATES_DATATABLE: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/global-template/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int
  ATTACH_GLOBAL_TO_PROJECT: ({ commit, dispatch }, {projectId, engineId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/global-template/projects/${projectId}/engine/${engineId}`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int
  DELETE_GLOBAL: ({ commit, dispatch }, globalId) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/project-global-template/${globalId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int
  GET_GSC_BASE_CHARTS: ({ commit, dispatch }, projectId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/search-console-info-by-date`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id; engine_id: int; datatable
  GET_GSC_KEYWORDS_RANKING_TABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/search-console-info-by-keywords`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id; datatable
  GET_AVG_CTR_TABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/search-console/projects/${projectId}/avg-ctr-datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id; datatable
  GET_GSC_PAGES_DATATABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/search-console-pages`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // engine_id: int
  GET_INDEXED_BUT_NOT_RANKING_PAGES_TABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/urls/indexed-page-not-serps`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // engine_id: int, engine_id=int, urls_indexed_pages_ids=[], url_type=int, visibility=int, remarks=None, str,
  SET_INDEXED_PAGES_VISIBILITY: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/urls/indexed-page/visibility`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // engine_id: int
  GET_LONG_TITLE_URLS_TABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/hidden-urls/indexed-page`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // engine_id: int
  COMPETITORS_KEYWORDS_I_AM_NOT_RANKING: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/top-competitors-keywords`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DOWNLOAD_GLOBAL_PDF: ({ commit, dispatch }, {globalId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/global-template-project/${globalId}/generate`, params, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBAL_SCHEDULER_TABLE: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/schedulers/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // additional_params: str or None
  // project_global_template_id: int
  // generate_at: str or None /* next generation */
  // emails: dict
  // date_range_type: int
  // period: int
  CREATE_GLOBAL_SCHEDULER: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/scheduler/generate`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBAL_SCHEDULER: ({ commit, dispatch }, schedulerId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/schedulers/${schedulerId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_GLOBAL_SCHEDULER: ({ commit, dispatch }, {schedulerId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/schedulers/${schedulerId}`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // schedulers_ids: List[int]
  DELETE_GLOBAL_SCHEDULER: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/schedulers-delete`, { body: params }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // from_date: str or None
  // to_date: str or None
  // date_range_type: int or 10 -( default week )
  // project_id: from url
  // url: str ( for specific url)
  // domain_level: bool = False (for specific domain)
  // get_only_live_data: bool = False ( get from с https://search.google.com/search-console)
  GET_GSC_PERFORMANCE_CHART: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/search-consoles/projects/${projectId}/performance/chart`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // get_only_live_data', True, bool
  GET_GSC_AVG_CTR_CHART: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/search-consoles/projects/${projectId}/avg-ctr/chart`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int
  // view_id: str
  GET_GSC_TRAFFIC_OVERVIEW_CHART: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ua/projects/${projectId}/organic-traffic-overview`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int
  // view_id: str
  GET_GSC_TRAFFIC_SOURCES_CHART: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ua/projects/${projectId}/traffic-source/chart`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int
  // view_id: str
  GET_GSC_TOP_TRAFFIC_SOURCES_CHART: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ua/projects/${projectId}/top-traffic-source`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GA4_TRAFFIC_SOURCES_CHART: ({ commit, dispatch }, projectId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ga4/projects/${projectId}/traffic-source/pie-chart`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GA4_TRAFFIC_DEVICES_CHART: ({ commit, dispatch }, projectId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ga4/projects/${projectId}/traffic-source-by-device/pie-chart`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GA4_TRAFFIC_DEVICES_TABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ga4/projects/${projectId}/traffic-source-by-device/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GA4_TRAFFIC_SOURCES_TABLE: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/google-analytics/ga4/projects/${projectId}//traffic-source/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: from url
  // engine_id: int
  GET_GLOBAL_SUMMARY: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/summary-info`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // emails: List[str]
  GLOBAL_SHARE_FOR_EMAILS: ({ commit, dispatch }, {globalId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/global-template-project/${globalId}/share`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBAL_PUBLIC_KEY: ({ commit, dispatch }, globalId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/global-template-project/${globalId}/public-key`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // public: bool
  SET_GLOBAL_AS_PUBLIC: ({ commit, dispatch }, {globalId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/global-template-project/${globalId}/public-key`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // project_id: int or None
  GET_GLOBAL_DASHBOARD_TABLE: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/global-dashboard/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // global_dashboard_id: из url
  // order: int or None
  // dashboard_type: int ( default 0)  --->>>> Default - 0, Main - 1
  // name: str or None
  SET_GLOBAL_AS_DASHBOARD: ({ commit, dispatch }, {globalId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/project-global-template/${globalId}/create-dashboard`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  UPDATE_GLOBAL_TEMPLATE: ({ commit, dispatch }, {globalId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/project-global-template/${globalId}`, params,
        { headers: {'Content-Type': 'multipart/form-data'} }
      ).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // global_dashboard_id: из url
  // order: int or None
  // dashboard_type: int ( default 0)  --->>>> Default - 0, Main - 1
  // name: str or None
  EDIT_GLOBAL_DASHBOARD: ({ commit, dispatch }, {globalDashboardId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/global-dashboard/${globalDashboardId}`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_GLOBAL_DASHBOARD: ({ commit, dispatch }, globalDashboardId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/global-dashboard/${globalDashboardId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_GLOBAL_DASHBOARD: ({ commit, dispatch }, globalDashboardId) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/global-dashboard/${globalDashboardId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/global/actions.js